import React, { useEffect, useState } from "react";
import MediaModal from "./MediaModal";
import { CircularProgress, Box, Dialog } from "@mui/material";

const EditMediaModal = ({ open, onClose, data, onSave, readOnly = false }) => {
  const [ready, setReady] = useState(false);
  const [titlePairs, setTitlePairs] = useState([]);
  const [descriptionPairs, setDescriptionPairs] = useState([]);
  const [linkPairs, setLinkPairs] = useState([]);

  useEffect(() => {
    if (!open || !data) { setReady(false); return; }

    const titlePairsFromData = (data.textLocalizations || []).map((v) => ({
      localeId: v.localeId,
      value: v.value || "",
    }));

    const descPairsFromData = (data.descriptionLocalizations || []).map((v) => ({
      localeId: v.localeId,
      value: v.value || "",
    }));

    const linkPairsFromData = (data.linkLocalizations || []).map((l) => ({
      localeId: l.localeId,
      mediaLink: l.mediaLink || "",
    }));

    setTitlePairs(titlePairsFromData);
    setDescriptionPairs(descPairsFromData);
    setLinkPairs(linkPairsFromData);
    setReady(true);
  }, [open, data]);

  if (!ready || !data) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
        PaperProps={{ sx: { borderRadius: 3, display: "flex", alignItems: "center", justifyContent: "center", minHeight: 200 } }}
      >
        <Box sx={{ p: 6 }}>
          <CircularProgress />
        </Box>
      </Dialog>
    );
  }

  return (
    <MediaModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      isEditing
      readOnly={readOnly}
      initialMediaTypeId={data.mediaTypeId}
      initialTitlePairs={titlePairs}
      initialDescriptionPairs={descriptionPairs}
      initialLinkPairs={linkPairs}
    />
  );
};

export default EditMediaModal;
